import { TextareaHTMLAttributes } from 'react'

interface FormTextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string
  labelSuffix?: string
  error?: string
  charCount?: number
  maxChars?: number
}

export const FormTextarea = ({
  label,
  labelSuffix,
  error,
  charCount,
  maxChars,
  className,
  ...rest
}: FormTextareaProps): JSX.Element => {
  return (
    <div>
      <label className="block subtitle-m mb-2 text-neutral-80">
        {label}
        {labelSuffix && <span className="normal-case body-s text-neutral-80 align-baseline"> {labelSuffix}</span>}
      </label>
      <textarea
        {...rest}
        className={`w-full border rounded-md px-2.5 py-2 text-sm placeholder-[#6E6E6E] outline-none resize-none transition
          ${error ? 'border-red-60' : 'border-[#9B9B9B] focus:border-black'}
          ${className ?? ''}`}
        maxLength={maxChars}
      />
      <div className="flex justify-between items-center mt-1">
        {error ? <p className="text-error">{error}</p> : <span />}
        {maxChars !== undefined && (
          <p className="grow text-right text-[#505050] font-normal text-xs">
            Characters:{' '}
            <span className="text-xs !align-baseline font-bold">
              {charCount || 0}/{maxChars}
            </span>
          </p>
        )}
      </div>
    </div>
  )
}
